angular.module('impactx.MenuDirectives').controller('MessageInfoDialogCtrl', ['$scope', '$mdDialog', 'dataGen', '$context', '$redirect', 'MessageService', MessageInfoDialogCtrl]);

function MessageInfoDialogCtrl($scope, $mdDialog, dataGen, $context, $redirect, MessageService) {
    $scope.customerServiceUserShown = $context.customerServiceUser.value;
    var getData = function() {
        dataGen.getData($scope, {}, "/message/overview/info", null, true).then(function () {
            var data = $scope.data;
            if (data !== null && data !== undefined)
            {
                $scope.messages = data.messages;
            }
        });
    };
    getData();

    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.goToMessageInfoList = function () {
        $redirect.redirectTo(null, '/messageinfolist');
        $scope.hide();
    };

    $scope.goToDetailPage = function (id) {
        $redirect.redirectTo(null, '/message/' + id);
        $scope.hide();
    };

    $scope.delete = function (id) {
        var dataObj = {
            ids: [id]
        };
        dataGen.postAsForm({}, dataObj, '/message/delete').then(function() {
            getData();
            MessageService.getInfoOnce();
        });
    };

    $scope.markRead = function (id) {
        var dataObj = {
            ids: [id]
        };
        dataGen.postAsForm({}, dataObj, '/message/markread').then(function () {
            getData();
            MessageService.getInfoOnce();
        });
    };

    $scope.reply = function (id) {
        $redirect.redirectTo(null, '/message/' + id + '/reply');
        $scope.hide();
    };

    $scope.followMessageLink = function (message) {
        if (message.route) {
            var dataObj = {
                ids: [message.id]
            };
            dataGen.postAsForm({}, dataObj, '/message/markread').then(function () {
                $redirect.redirectTo(null, message.route);
                $scope.hide();
            });
        }
    };

    $scope.canSendMessage = function () {
        return MessageService.canSendMessage();
    };
}